import React from 'react'
import { Outlet } from 'react-router-dom'
import Tab from "components/tabs/tabs";

import Email from "assets/images/svg/email_dark.svg";
import Phone from "assets/images/svg/phone_dark.svg";
import Lock from "assets/images/svg/lock_dark.svg";
import {useTranslation} from "react-i18next";
import CanLoadGuard from "components/private-route/can-load.guard";

const  SecurityLoginPage = () => {
  const {t} = useTranslation('security');

  return (
    <div className="settings securityLogin">
    <div className="header">
            <h1 className='title'>{t('title')}</h1>
    </div>
    <hr className="hr" />

      <div className="tabs">
        <div className="nav">
          <Tab url="email" title={t('email')} img={Email} />
          <Tab url="phone" title={t('phone-number')} img={Phone} />
          <CanLoadGuard>
              <Tab url="change-password" title={t('change-password')} img={Lock} />
          </CanLoadGuard>
        </div>
      </div>

    <Outlet />
    </div>
  )
}

export default  SecurityLoginPage